/**
 * Helper: CSS classes
 * -----------------------------------------------------------------------------
 * Global configuration for css classes.
 * - Used to provide consistency and keep DRY for our toggle classes.
 */
 export default {
    active: 'is-active',
    adding: 'is-adding',
    added: 'is-added',
    collapsed: 'is-collapsed',
    disabled: 'is-disabled',
    focused: 'is-focused',
    hidden: 'is-hidden',
    loaded: 'is-loaded',
    loading: 'is-loading',
    locked: 'is-locked',
    removing: 'is-removing',
    sticky: 'is-sticky',
    transitioning: 'is-transitioning',
    headerClear: 'site-header--transparent',
  };